import Icon from '../components/Icon';

export const svgContents = (
  <>
    <path d="M12.17 22.455a.75.75 0 0 0 .916-.328l4.066-7.09a.75.75 0 0 0 .1-.374V4.5a.75.75 0 0 0-.75-.75H6.759a3.75 3.75 0 0 0-3.663 2.947L1.535 13.82a2.75 2.75 0 0 0 2.686 3.339h4.586v.742a4.75 4.75 0 0 0 3.066 4.441zM21 15a1.5 1.5 0 0 0 1.5-1.5V5.25a1.5 1.5 0 0 0-1.5-1.5h-2.5V15z" />
  </>
);

const ThumbsDownFilled = Icon('thumbs-down-filled', svgContents);

export default ThumbsDownFilled;
